<template>
  <div class="UserAddress">
    <div class="UserAddress-wrap">
      <UserLeft
        defaultItem="/shop/user/address"
      />
      <div class="right-content">
        <div class="header-top">
          <p>{{TLang('您已创建','list')}}<span>{{ total }}</span>{{TLang('个收货地址最多可创建','list')}}<span>25</span>{{TLang('个','list')}}</p>
          <div
            :class="{disabled: total >= 25}"
            @click="handleClickAdd"
          >
            + {{TLang('新建收货地址','orderConfirm')}}
          </div>
        </div>
        <div class="address-table">
          <header>
            <div class="consignee">
              {{TLang('收货人','address')}}
            </div>
            <div class="address">
              {{TLang('收货地址','address')}}
            </div>
            <div class="mobile">
              {{TLang('联系方式','list')}}
            </div>
            <div class="opration">
              {{TLang('操作','list')}}
            </div>
            <div></div>
          </header>
          <ul v-if="addressData.length">
            <li
              v-for="(address,i) in addressData"
              :key="i"
              class="address-li"
            >
              <div class="address-li_consignee">
                <p>
                  {{ address.consignee }}
                </p>
              </div>
              <div class="address-li_address">
                <p class="line-clamp-3">
                  {{ address.provinceName
                    + address.cityName
                    + address.regionName
                    + address.streetName
                    + address.address }}
                </p>
              </div>
              <div class="address-li_mobile">
                {{ address.mobile }}
              </div>
              <div class="address-li_opration">
                <span
                  class="edit"
                  @click="handleClickEdit(address)"
                >{{TLang('编辑','address')}}</span>
                <span
                  class="delete"
                  @click="handleDelAddress(address)"
                >{{TLang('删除','address')}}</span>
              </div>
              <div class="address-li_isdefault">
                <span
                  :class="{isDefault:address.defaultAddress === 1 }"
                  @click="handleSetDefault(address)"
                >
                  {{ address.defaultAddress === 1 ? TLang('默认地址','address') : TLang('设为默认','address') }}
                </span>
              </div>
            </li>
          </ul>
          <div
            v-else
            class="address_empty"
          >
            <img :src="require('@assets/images/address_empty.png')" />
            <p>
              {{TLang('您还没有收货地址','list')}}
            </p>
            <p>{{TLang('快去新建吧','list')}}</p>
            <div
              class="create-btn"
              @click="handleClickAdd"
            >
              {{TLang('新建收货地址','orderConfirm')}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditOrAddModal
      ref="popus"
      :showPopus="editORaddModal"
      :title="addressDialog.title"
      :addressItem="addressDialog.addressItem"
      width="50%"
      custom-class="editORaddModal"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="editORaddModal = false"
    >
    </EditOrAddModal>
    <Dialog
      :visible="delModal"
      width="420px"
      title=" "
      custom-class="delModal"
      @close="delModal = false"
    >
      <img src="@assets/images/delete.png" />
      <h2>{{TLang('您要删除该收货地址吗','address')}}</h2>
      <div class="del-footer">
        <div
          class="confirm"
          @click="handleConfrimDelete"
        >
          {{TLang('删除','address')}}
        </div>
        <div
          class="cancel"
          @click="delModal = false"
        >
          {{TLang('再想想','address')}}
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import UserLeft from './../order/OrderList/components/user/index.vue';
import { fetchAddressList, fetchAddressUpdate, fetchAddressCreate, fetchAddressDelete } from '@fetch/address';
import { Dialog } from 'element-ui';
import EditOrAddModal from './../order/OrderConfirm/components/orderAddress/popups';
export default {
  name:'UserAddress',
  components: {UserLeft, EditOrAddModal, Dialog},
  data(){
    return {
      addressData: [],
      editORaddModal: false,
      addressDialog: {
        title: this.TLang('新增收货地址','orderConfirm'),
        addressItem: null,
        type: 'ADD',
      }, // 地址新建、编辑弹层
      total: 0,
      delModal: false,
      delAddress: {},

    };
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      fetchAddressList({channel: 1, ignore: false }).then(res => {
        if(res.code) return;
        this.addressData = res;
        this.total = res.length;
      });
    },
    handleClickEdit(address){
      this.editORaddModal = true;
      this.addressDialog = {
        title: this.TLang('编辑收货地址','orderConfirm'),
        addressItem: {...address},
        type: 'EDIT',
      };
    },
    handleClickAdd(){
      if(this.total >= 25) return;
      this.editORaddModal = true;
      this.addressDialog = {
        title: this.TLang('新增收货地址','orderConfirm'),
        addressItem: null,
        type: 'ADD',
      };
    },
    handleSetDefault(address){
      if(!address.defaultAddress){
        fetchAddressUpdate({...address,defaultAddress: 1, channel: 1 }).then(res => {
          if(res.code === 0){
            this.init();
          }
        });
      }
    },
    onConfirmEditAddressDialog(address){
      const { type } =  this.addressDialog;
      if(type === 'ADD'){
        fetchAddressCreate({...address,channel: 1 }).then(res => {
          if(res.code === 0){
            this.init();
          }
        });
        return;
      }
      if(type === 'EDIT'){
        fetchAddressUpdate({...address, channel: 1 }).then(res => {
          if(res.code === 0){
            this.init();
          }
        });
        return;
      }
    },
    handleDelAddress(address){
      this.delModal = true;
      this.delAddress = address;
    },
    handleConfrimDelete(){
      fetchAddressDelete({userAddressId: this.delAddress.id}).then(res => {
        if(res.code === 0){
          this.init();
        }
      });
      this.delModal = false;
      this.delAddress = {};
    },
    onCancelEditAddressDialog(){
      this.editORaddModal = false;
    },
  },
};
</script>
<style lang="less">
.UserAddress{
  .UserAddress-wrap{
    display: flex;
    .right-content{
      flex: 1;
      .header-top{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        p{
          margin-left: 10px;
          line-height: 26px;
          margin-top: 6px;
          font-size:12px;
          font-family:MicrosoftYaHei;
          color:rgba(153,153,153,1);
          span{
            color: rgb(61, 150, 226);
          }
        }
        div{
          &:hover{
            color: rgb(61, 150, 226);
            cursor: pointer;
          }
        }
        .disabled{
          color: #999;
          &:hover{
            color: #999;
            cursor:auto;
          }
        }
      }
      .address-table{
        margin-left: 10px;

        header{
          display: flex;
          height: 40px;
          color: #666;
          line-height: 40px;
          background: #F0F0F0;
          border-left: 1px solid #ccc;
          border-top: 1px solid #ccc;
          border-right: 1px solid #ccc;

          .consignee,.mobile,.opration,.address{
            width: 120px;
            padding-left: 15px;
            box-sizing: border-box;
            border-right: 1px solid #ccc;
            font-size:12px;
            font-family:MicrosoftYaHei !important;
            color:rgba(102,102,102,1);
            font-weight: 400 !important;
          }
          .address{
            width: 480px;
            font-size:12px;
            font-family:MicrosoftYaHei !important;
            color:rgba(102,102,102,1);
            font-weight: 400 !important;
          }
        }
        ul{
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
          // transform: translateX(-1px);
          .address-li{
            display: flex;
            font-size:12px;
            font-family:MicrosoftYaHei;
            color:rgba(17,17,17,1);
            height: 72px;
            line-height: 72px;
            border-bottom: 1px solid #ccc;
            align-items: center;
            &_consignee,&_mobile,&_opration,&_address{
              width: 120px;
              padding-left: 15px;
              box-sizing: border-box;
              border-right: 1px solid #ccc;
            }
            &_address{
              width: 480px;
              height: 72px;
              display: flex;
              align-items: center;
              p{
                line-height: 22px;
                word-break: break-all;
              }
            }
            &_consignee{
              // width: 480px;
              height: 72px;
              display: flex;
              align-items: center;
              p{
                line-height: 22px;
                word-break: break-all;
              }
            }
            &_opration{
              text-align: center;
              padding-left: 0;
              .delete{
                margin-left: 20px;
              }
              .delete,.edit{
                &:hover{
                  color: #3D96E2;
                  cursor: pointer;
                }
              }
            }
            &_isdefault{
              flex: 1;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
              span{
                &:hover{
                  color: #3D96E2;
                }
              }
              span.isDefault{
                width:80px;
                height:32px;
                background:rgba(255,246,230,1);
                border-radius:2px;
                color:rgba(255,175,0,1);
                line-height: 32px;
              }
              &:hover{
                  cursor: pointer;
                }
            }
          }
        }
        .address_empty{
          text-align: center;
          img{
            width: 375px;
            margin-top: 60px;
            margin-right: 15px;
          }
          p{
            font-size:15px;
            font-family:MicrosoftYaHei;
            color:rgba(153,153,153,1);
            line-height:26px;
          }
          div{
            width:135px;
            height:40px;
            background:linear-gradient(315deg,rgba(92,180,236,1) 0%,rgba(61,150,226,1) 100%);
            border-radius:4px;
            margin: 0 auto;
            font-size:14px;
            font-family:MicrosoftYaHei-Bold,MicrosoftYaHei;
            font-weight:bold;
            color:rgba(255,255,255,1);
            line-height: 40px;
            margin-top: 50px;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .editORaddModal,.delModal{
    margin-top: 50vh !important;
    transform: translateY(-50%);
  }
  .delModal{
    .el-dialog__header{
      padding: 0;
    }
    .el-dialog__body{
      text-align: center;
      h2{
        font-size:18px;
        font-family:MicrosoftYaHei;
        color:rgba(51,51,51,1);
        font-weight: 400;
      }
      .del-footer{
        display: flex;
        justify-content: center;
        margin-top: 32px;
        div{
           width:88px;
          height:40px;
          border-radius:4px;
          font-size:14px;
          font-family:MicrosoftYaHei-Bold,MicrosoftYaHei;
          line-height: 40px;
          &:hover{
            cursor: pointer;
          }
        }
        .confirm{
          background:linear-gradient(315deg,rgba(92,180,236,1) 0%,rgba(61,150,226,1) 100%);
          font-weight:bold;
          color:rgba(255,255,255,1);
        }
        .cancel{
          border:1px solid rgba(229,229,229,1);
          color: #999999;
          background: #fff;
          margin-left: 32px;
        }
      }
    }
  }
}
</style>